module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxOSIgdmlld0JveD0iMCAwIDE0IDE5Ij4KICAgIDxwYXRoIGZpbGw9IiMyQjMyM0IiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTS4yODkgOS43NUwxMy4zOTYuOTA4djE3LjY4NHoiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/left-triangle.svg
// module id = KQFn
// module chunks = 6